import React, { Component } from 'react';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import AutoComplete from '../common/autoComplete';
import Button from '../common/button';
import RadioButton from '../common/radioButton';

import './styles.css';

function hightLightText(str, val) {
  var index = str.toLowerCase().indexOf(val.toLowerCase());
  if(index > 0) {
    return [
      str.substring(0, index),
      <b key={1} style={{ color: '#000' }}>{val}</b>,
      str.substring(index+val.length),
    ];
  } else if(index === 0) {
    return [
      <b key={1} style={{ color: '#000' }}>{str.substring(0, index+val.length)}</b>,
      str.substring(index+val.length)
    ];
  }
  return str;
}

const renderElements = function (item, value) {
  return (
    <div className='cursor'>
      <p className='cityStyle'>
        {
          value ?
            hightLightText(item.city_name || item.display_name, value)
          : item.city_name
        }
        {(item.is_multi_district && item.district) ? ` (${item.district})` : ''}
      </p>
      <p className='stateStyle'>{item.state || ''}</p>
    </div>
  );
};

const DriverName = 'driverName';
const DriverVehicleNumber = 'vehicleNumber';
const DriverPhoneNumber = 'driverPhoneNumber';
const DriverAltPhoneNumber = 'driverAltPhoneNumber';

class DriverDetailsComponent extends Component{
  constructor(props){
    super(props);
    this.state = {
      tripDriverMap : {}, // driver info will be saved per trip_id
      tripSelectedMap : {} // if selected trip_id checked true/false
    }
  }

  handleServiceCheckbox = (is_checked, service) => {
    this.setState({
      tripSelectedMap : {
        ...this.state.tripSelectedMap , ...{[service.trip_id] : is_checked}
      }
    })
  }

  handleDriverInfoChange = (value, key, service) => {
    let tripId = service.trip_id;
    // if tripId already exists
    let newObj;
    if(this.state.tripDriverMap.hasOwnProperty(tripId)){
      newObj = {...this.state.tripDriverMap[tripId]};
      newObj.driverInfo[key] = value;
    } else {
      newObj = {
        serviceInfo: service,
        driverInfo: {
          [DriverName] : undefined,
          [DriverVehicleNumber] : undefined,
          [DriverPhoneNumber] : undefined,
          [DriverAltPhoneNumber] : undefined
        }
      }
      newObj.driverInfo[key] = value;
    }
    this.setState({
      tripDriverMap : {...this.state.tripDriverMap, ...{[tripId] : newObj}}
    })
  }

  renderUpdateButton(){
    if(Object.keys(this.state.tripSelectedMap).length === 0){
      alert("Please select atleast one service")
      return false;
    }

    let values = Object.values(this.state.tripSelectedMap);
    let falseValues = values.filter(value => value === false);
    if(falseValues.length === Object.keys(this.state.tripSelectedMap).length){
      alert("Please select atleast one service")
      return false;
    }

    let trueValues = Object.keys(this.state.tripSelectedMap).filter(key =>  this.state.tripSelectedMap[key] === true)
    for(let i = 0; i < trueValues.length; i++){
      if(this.state.tripDriverMap.hasOwnProperty(trueValues[i])){
        continue;
      } else {
        alert("Please fill out the details")
        return false
      }
    }

    return true

  }

  render(){
    return(
      <div className="updateDriverDetailsContent">
          <div className="row">
              <div className="col-xs-3">
                  <AutoComplete
                  name="source"
                  openOnFocus={true}
                  placeholder="Source *"
                  onSelect={this.props.onSourceItemSelect}
                  defaultValue={this.props.source}
                  fieldName='source'
                  onChange={this.props.fetchCities}
                  renderElements={renderElements}
                  listData={this.props.sourceCityData}
                  />
              </div>
              <div className="col-xs-3">
                  <AutoComplete
                  openOnFocus={true}
                  name="destination"
                  placeholder="Destination *"
                  onSelect={this.props.onDestinationItemSelect}
                  defaultValue={this.props.destination}
                  fieldName='destination'
                  onChange={this.props.fetchCities}
                  renderElements={renderElements}
                  listData={this.props.destCityData}
                  />
              </div>
              <div className="col-xs-3 deal-date-range-wrp padTop7">
                  <SingleDatePicker
                      id="journey_date"
                      daySize={30}
                      showClearDate
                      date={this.props.journeyDate}
                      placeholder="Journey Date"
                      displayFormat="DD-MM-YYYY"
                      focused={this.props.focusedJourneyDate}
                      hideKeyboardShortcutsPanel={true}
                      onDateChange={this.props.onJourneyDateChange}
                      onFocusChange={this.props.onJourneyDateFocusChange}
                      isOutsideRange={this.props.journeyDateRangeChecker}
                  />
              </div>
              <div className="col-xs-3 searchButton">
                  <Button label="Search"  onButtonClick={this.props.onSearchClick}/>
              </div>
          </div>

          {this.props.routeServices.length ?
              <React.Fragment>
                <p className="marginTop20 marginLeft10">Select services to add</p>
                <div className="">
                    {
                    this.props.routeServices.map((service, index) => (
                        <div key={index} className="updateDriverDetailsServices">
                          <div>
                            <input type="checkbox" className="checkBox" onChange = {(e) => {
                              this.handleServiceCheckbox(e.target.checked, service)
                            }}/>
                            {`${moment(service.departure_datetime).format('hh:mm a')}, ${service.bus_type_name}`}
                          </div>
                          {
                          this.state.tripSelectedMap[service.trip_id] &&
                            <div className="row driverInfoWrapper">
                              <div className="driverInfoInput col-xs-3">
                                <input
                                  type="text"
                                  required
                                  value = {this.state.tripDriverMap[service.trip_id] ? this.state.tripDriverMap[service.trip_id][DriverName] : undefined }
                                  placeholder="Driver Name *"
                                  onChange = {(e) => this.handleDriverInfoChange(e.target.value, DriverName /* key */, service)}/>
                              </div>
                              <div className="driverInfoInput col-xs-3">
                                <input
                                  type="text"
                                  required
                                  value = {this.state.tripDriverMap[service.trip_id] ? this.state.tripDriverMap[service.trip_id][DriverVehicleNumber] : undefined }
                                  placeholder="Vehicle Number *"
                                  onChange = {(e) => this.handleDriverInfoChange(e.target.value, DriverVehicleNumber /* key */, service)}/>
                              </div>
                              <div className="driverInfoInput col-xs-3">
                                <input
                                  type="number"
                                  required
                                  value = {this.state.tripDriverMap[service.trip_id] ? this.state.tripDriverMap[service.trip_id][DriverPhoneNumber] : undefined }
                                  placeholder="Phone Number *"
                                  onChange = {(e) => this.handleDriverInfoChange(e.target.value, DriverPhoneNumber /* key */, service)}/>
                              </div>
                              <div className="driverInfoInput col-xs-3">
                                <input
                                  type="number"
                                  value = {this.state.tripDriverMap[service.trip_id] ? this.state.tripDriverMap[service.trip_id][DriverAltPhoneNumber] : undefined }
                                  placeholder="Alt Phone Number (optional)"
                                  onChange = {(e) => this.handleDriverInfoChange(e.target.value, DriverAltPhoneNumber /* key */, service)}/>
                              </div>
                            </div>
                        }
                        </div>
                    ))
                    }
                </div>
                <div className="col-xs-12">
                  <button className="saveButton" label="Update"
                    onClick={ (e) => this.renderUpdateButton() ? this.props.onSaveClick(this.state.tripDriverMap) : false}>Update</button>
                </div>
              </React.Fragment>
              : null
          }
      </div>
    )
  }


}

export default DriverDetailsComponent